import { useState } from "react";
import { Phone, ArrowUpRight, Menu, X } from "lucide-react";
import { CONTACT, NAV_LINKS, LINKS } from "../data/site";

export const Header = () => {
  const [open, setOpen] = useState(false);
  return (
    <header
      data-testid="site-header"
      className="fixed top-0 inset-x-0 z-50 border-b border-line bg-cream/90 backdrop-blur-md"
    >
      <div className="mx-auto flex h-16 md:h-20 max-w-7xl items-center justify-between gap-4 px-4 sm:px-6 lg:px-8">
        <a href="#hero" className="flex items-center gap-3" data-testid="header-logo">
          <img
            src="/assets/logo.png"
            alt="Comfort Line Bútoráruház logó"
            className="h-8 md:h-10 w-auto"
          />
          <span className="rounded-full bg-burgundy px-3 py-1 text-xs font-bold uppercase tracking-wider text-white">
            Keszthely
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-7" data-testid="header-nav">
          {NAV_LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.href.slice(1)}`}
              className="text-sm font-semibold text-soft transition-colors hover:text-burgundy"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href={CONTACT.phoneHref}
            data-testid="header-phone-link"
            className="hidden md:inline-flex items-center gap-2 text-sm font-bold text-ink transition-colors hover:text-burgundy"
          >
            <Phone className="h-4 w-4 text-burgundy" />
            {CONTACT.phone}
          </a>
          <a
            href={LINKS.mainSite}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="header-cta-button"
            className="btn-pill hidden sm:inline-flex bg-burgundy text-white hover:bg-burgundydark"
          >
            comfortbutor.hu
            <ArrowUpRight className="h-4 w-4" />
          </a>
          <button
            data-testid="mobile-menu-button"
            onClick={() => setOpen(!open)}
            className="lg:hidden inline-flex h-10 w-10 items-center justify-center rounded-full border border-line bg-white text-ink"
            aria-label="Menü"
          >
            {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>
      </div>

      {open && (
        <div
          data-testid="mobile-menu"
          className="lg:hidden border-t border-line bg-cream px-4 py-4"
        >
          <div className="flex flex-col gap-1">
            {NAV_LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-link-${l.href.slice(1)}`}
                className="rounded-xl px-4 py-3 text-sm font-semibold text-ink hover:bg-cream2"
              >
                {l.label}
              </a>
            ))}
            <a
              href={CONTACT.phoneHref}
              data-testid="mobile-phone-link"
              className="mt-2 inline-flex items-center gap-2 rounded-xl bg-burgundy px-4 py-3 text-sm font-bold text-white"
            >
              <Phone className="h-4 w-4" /> {CONTACT.phone}
            </a>
          </div>
        </div>
      )}
    </header>
  );
};
